import { makeStyles } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import React from "react";

import { useVenueSelection } from "../../hooks/useVenueSelection";
import ILocationAPIObject from "../../interfaces/ILocationAPI";
import IVenue from "../../interfaces/IVenue";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import { VenueIdWrapper } from "./VenueIdWrapper";
import { VenueTitle } from "./VenueTitle";

export const useStyles = makeStyles({
  root: {
    width: "100%",
    borderRadius: "0.5rem",
    display: "flex",
    alignItems: "center",
    transition: "0.25s ease-in-out",
    position: "relative",
    flexDirection: "column",
    background: "#FFFFFF",
    padding: "1.5625rem",

    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#F3F4F9",
    },
    "&:active": {
      backgroundColor: "#E7EAF1",
    },
  },
  img: {
    width: "3.5rem",
    height: "3.5rem",
    borderRadius: "0.5rem",
    background: "rgba(234, 234, 234, 0.3)",
  },
  imgWrapper: {
    display: "flex",
    alignItems: "center",
    maxWidth: "3.75rem",
    maxHeight: "3.75rem",
    width: "3.75rem",
    height: "3.75rem",
    marginRight: "1.25rem",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    color: "#BDBDBD",
  },
  iconVenue: {
    right: "2rem",
    "& svg": {
      width: "3.5rem",
      height: "3.5rem",
      marginRight: "1.25rem",
    },
  },
  iconAdd: {
    right: ".4rem",
    "& svg": {
      width: "1.4rem",
      height: "1.4rem",
    },
  },
  content: {
    flexGrow: 4,
    lineHeight: "2.6rem",
    width: "85%",
    fontSize: "1rem",
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    flexDirection: "column",
  },
  venueId: {
    width: "85%",
    display: "flex",
    justifyContent: "center",
    marginLeft: "2rem",
  },
  venueWrapper: {
    display: "flex",
    width: "100%",
  },
});

interface IVenueViewCard {
  venue: IVenue;
  onClose?: () => void;
  isLoading?: boolean;
  venueId?: number;
  hideChev?: boolean;
  disabled?:boolean;
}

export function VenueViewCard({
  venue,
  onClose,
  isLoading = false,
  venueId,
  hideChev = false,
  disabled
}: IVenueViewCard) {
  const selectVenue = useVenueSelection();
  const { apiData: locationData } = useAPIV2<ILocationAPIObject>(
    APIExtensions.locations,
    {
      selectorKeyParams: { venue_id: venue.id },
      dispatcherParams: [venue.id!],
      query: venue.location_id,
    }
  );
  const classNames = useStyles();
  function onClick() {
    const venueId = venue.id!;
    if (venueId && !disabled) {
      selectVenue(venueId);
      onClose?.();
    }
  }
  return (
    <div
      data-component-name="VenueViewCard"
      className={classNames.root}
      onClick={onClick}
    >
      <div className={classNames.venueWrapper}>
        <div className={classNames.imgWrapper}>
          {isLoading ? (
            <Skeleton
              variant="rect"
              className={classNames.img}
              animation="wave"
            />
          ) : venue?.url_logo ? (
            <img
              alt={"venue logo"}
              className={classNames.img}
              src={venue?.url_logo}
            />
          ) : (
            <div className={classNames.img}></div>
          )}
        </div>
        <div className={classNames.content}>
          <VenueTitle
            location={locationData!}
            venue={venue}
            isLoading={isLoading}
          />
        </div>
        {!hideChev && (
          <div className={classNames.icon}>
            <ChevronRight />
          </div>
        )}
      </div>
      {venueId && (
        <div className={classNames.venueId}>
          <VenueIdWrapper venueId={venueId} />
        </div>
      )}
    </div>
  );
}
